import { render, staticRenderFns } from "./boxset-icon.vue?vue&type=template&id=2d3b32ea&"
import script from "./boxset-icon.vue?vue&type=script&lang=js&"
export * from "./boxset-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports